import { MapperType } from "./MapperType";

export const mapperKeys = {
	[MapperType.loading]: [
		"desc",
		"move_order",
		"packaging",
		"pallet_number",
		"sscc",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.unloading]: [
		"desc",
		"move_order",
		"move_order_2",
		"production",
		"pallet_number",
		"sscc",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.loading_unloading_cc]: [
		"desc",
		"move_order",
		"move_order_2",
		"packaging",
		"production",
		"pallet_number",
		"sscc",
		"units",
		"weight",
		"box_weight",
		"optional",
		"custom",
	],
	[MapperType.incoming_pallet_import]: [
		"quantity",
		"net_weight",
		"ext_id",
		"sscc",
		"product_number",
		"product_name",
		"production_datetime",
		"expiration_datetime",
		"batch_number",
		"lot_number",
		"packing_station",
		"box_sscc",
		"boxes",
	],
	[MapperType.outgoing_pallet_import]: [
		"quantity",
		"net_weight",
		"ext_id",
		"sscc",
		"product_number",
		"product_name",
		"production_datetime",
		"expiration_datetime",
		"batch_number",
		"lot_number",
		"packing_station",
		"box_sscc",
		"boxes",
		"box_movement_notes",
	],
	[MapperType.order_import]: [
		"terminal_name",
		// "customer_name",
		"reference",
		"service_name",
		"outgoing_trip_number",
		"eta_date",
		"eta_time",
		"eta_3rd_party",
		"etd_date",
		"etd_time",
		"etd_3rd_party",
		"eta_truck",
		"eta_trailer",
		"etd_truck",
		"etd_trailer",
		"eta_driver",
		"etd_driver",
		"eta_driver_phone",
		"etd_driver_phone",
		"pallets",
		"kilos",
		"boxes",
		"loading_sequence",
		"notes",
	],
};

export const requiredMapperKeys = {
	[MapperType.loading]: ["move_order", "pallet_number", "units", "weight", "box_weight"],
	[MapperType.unloading]: [
		"desc",
		"move_order",
		"production",
		"pallet_number",
		"units",
		"weight",
		"box_weight",
	],
	[MapperType.loading_unloading_cc]: [
		"move_order",
		"production",
		"pallet_number",
		"units",
		"weight",
		"box_weight",
	],
	[MapperType.incoming_pallet_import]: ["quantity", "net_weight", "ext_id"],
	[MapperType.outgoing_pallet_import]: ["quantity", "net_weight", "ext_id"],
	[MapperType.order_import]: [],
	[MapperType.none]: [],
};
